const $inject = ['settingsService'];

const distanceFilter = (settingsService) => {
  return (distance) => {
    const isImperial = settingsService.settings.IsImperialSystem;
    let unit = isImperial ? 'mi' : 'km';
    let rounding = 2;

    if (distance < 1 && !isImperial) {
      const metresInKm = 1000;
      distance *= metresInKm;
      unit = 'm';
      rounding = 0;
    }

    distance = _.round(distance, rounding);

    return `${distance} ${unit}`;
  };
};

distanceFilter.$inject = $inject;

export default distanceFilter;



// WEBPACK FOOTER //
// ./src/filters/distanceFilter.js